import create from "zustand";
const createGlobalStorage = (initializer) => (create()(initializer));
export default createGlobalStorage;
